import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f0f9bff"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "text-center py-6"
}
const _hoisted_3 = {
  key: 2,
  class: "text-body-2 text-error text-center"
}
const _hoisted_4 = { class: "d-flex align-center ga-2 mb-1" }
const _hoisted_5 = { class: "text-subtitle-1 font-weight-bold flex-grow-1" }
const _hoisted_6 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis"
}
const _hoisted_7 = { class: "text-body-2 mb-1" }
const _hoisted_8 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis mb-3"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<h4 class=\"text-subtitle-2 font-weight-bold mb-1\" data-v-2f0f9bff>Sus ejércitos</h4><div class=\"fila cabecera text-caption text-medium-emphasis\" data-v-2f0f9bff><span data-v-2f0f9bff>Ejército</span><span class=\"text-right\" data-v-2f0f9bff>Part.</span><span class=\"text-right\" data-v-2f0f9bff>% vict.</span><span class=\"text-right\" data-v-2f0f9bff>Rinde</span></div>", 2)
const _hoisted_11 = ["onClick", "onKeydown"]
const _hoisted_12 = { class: "nombre" }
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-subtitle-2 font-weight-bold mt-4 mb-1" }, " Le cuesta contra ", -1))
const _hoisted_15 = {
  key: 1,
  class: "text-caption text-medium-emphasis mb-0"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fila cabecera text-caption text-medium-emphasis" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Rival"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-right" }, "Part."),
  /*#__PURE__*/_createElementVNode("span", { class: "text-right" }, "% vict."),
  /*#__PURE__*/_createElementVNode("span", { class: "text-right" }, "Rinde")
], -1))
const _hoisted_17 = { class: "nombre" }
const _hoisted_18 = { class: "text-right" }
const _hoisted_19 = { class: "text-right" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-caption text-medium-emphasis mt-1 mb-0" }, " Con 3 partidas o más, del peor al menos malo. ", -1))

import { computed, onMounted, ref, watch } from "vue";
import type {
  EjercitosJugadorDTO,
  FiltroEstadisticas,
} from "@/interfaces/Estadisticas";
import type { UsuarioIdNickDTO } from "@/interfaces/Usuario";
import { getEjercitosJugador } from "@/services/EstadisticasService";
import { getUsuariosIdNick } from "@/services/UsuariosService";
import { useAuth } from "@/composables/useAuth";
import { mensajeDelBack } from "@/utils/mensajeDelBack";
import {
  colorBando,
  colorRinde,
  textoPorcentaje,
  textoRinde,
} from "@/utils/estadisticasEjercitos";

// Con menos, un ejército no dice mucho de cómo le va
const MINIMO = 5;


export default /*#__PURE__*/_defineComponent({
  __name: 'JugadoresEjercitos',
  props: {
    filtro: {},
    jugadorInicial: {}
  },
  emits: ["ver"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// Se empieza por el jugador pedido o, si no, por quien mira
const { getidUsuario } = useAuth();
const idUsuario = ref<number | null>(
  props.jugadorInicial ?? (Number(getidUsuario.value) || null)
);
const jugadores = ref<UsuarioIdNickDTO[]>([]);
const datos = ref<EjercitosJugadorDTO | null>(null);
const cargando = ref(false);
const error = ref<string | null>(null);

onMounted(async () => {
  try {
    const respuesta = await getUsuariosIdNick();
    jugadores.value = (respuesta.data as UsuarioIdNickDTO[]).sort((a, b) =>
      a.nick.localeCompare(b.nick, "es")
    );
  } catch (e) {
    console.error("Error al cargar los jugadores:", e);
  }
});

watch(
  () => props.jugadorInicial,
  inicial => {
    if (inicial) idUsuario.value = inicial;
  }
);

const cargar = async () => {
  // Al limpiar el buscador no queda nadie elegido
  if (!idUsuario.value) {
    datos.value = null;
    return;
  }
  cargando.value = true;
  error.value = null;
  try {
    datos.value = await getEjercitosJugador(idUsuario.value, props.filtro);
  } catch (e) {
    error.value = mensajeDelBack(
      e,
      "No se han podido cargar sus ejércitos. Inténtalo de nuevo."
    );
  } finally {
    cargando.value = false;
  }
};
watch([idUsuario, () => props.filtro], cargar, { deep: true, immediate: true });

// Entre los ejércitos con bastantes partidas, el que más se sale de su media por arriba y el que más por abajo
const comparacion = computed(() => {
  if (!datos.value) return "";
  const media = datos.value.resumen.rinde;
  const fiables = datos.value.ejercitos.filter(e => e.partidas >= MINIMO);
  if (fiables.length < 2) return "";
  const ordenados = [...fiables].sort((a, b) => b.rinde - a.rinde);
  const mejor = ordenados[0];
  const peor = ordenados[ordenados.length - 1];
  const partes: string[] = [];
  if (mejor.rinde - media >= 1)
    partes.push(`le va mejor que de costumbre con ${mejor.ejercito}`);
  if (media - peor.rinde >= 1) partes.push(`peor con ${peor.ejercito}`);
  if (partes.length === 0)
    return "Le va más o menos igual con todos sus ejércitos.";
  const texto = partes.join(" y ");
  return `${texto.charAt(0).toUpperCase()}${texto.slice(1)}.`;
});

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_autocomplete, {
      modelValue: idUsuario.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((idUsuario).value = $event)),
      items: jugadores.value,
      "item-title": "nick",
      "item-value": "idUsuario",
      placeholder: "Busca un jugador",
      "prepend-inner-icon": "mdi-account-search",
      variant: "outlined",
      density: "compact",
      clearable: "",
      "hide-details": "",
      class: "mb-3"
    }, null, 8, ["modelValue", "items"]),
    (!idUsuario.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, " Busca un jugador para ver con qué ejércitos juega. "))
      : (cargando.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary"
            })
          ]))
        : (error.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(error.value), 1))
          : (datos.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h3", _hoisted_5, _toDisplayString(datos.value.nick), 1),
                  _createVNode(_component_v_btn, {
                    to: `/detalle-jugador/${datos.value.idUsuario}`,
                    variant: "text",
                    size: "small",
                    color: "primary",
                    class: "text-none",
                    "append-icon": "mdi-chevron-right"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Su ficha ")
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                (datos.value.resumen.partidas === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, " No tiene partidas con estos filtros. "))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("p", _hoisted_7, [
                        _createTextVNode(_toDisplayString(datos.value.resumen.partidas) + " partidas · " + _toDisplayString(datos.value.resumen.victorias) + "-" + _toDisplayString(datos.value.resumen.empates) + "-" + _toDisplayString(datos.value.resumen.derrotas) + " · " + _toDisplayString(_unref(textoPorcentaje)(datos.value.resumen.porcentaje)) + " de victorias · ", 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(_unref(colorRinde)(datos.value.resumen.rinde))
                        }, _toDisplayString(_unref(textoRinde)(datos.value.resumen.rinde)), 3),
                        _createTextVNode(" de «Rinde» ")
                      ]),
                      (comparacion.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(comparacion.value), 1))
                        : _createCommentVNode("", true),
                      _hoisted_9,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datos.value.ejercitos, (fila) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: fila.ejercito,
                          class: "fila pulsable text-body-2",
                          role: "button",
                          tabindex: "0",
                          onClick: ($event: any) => (emit('ver', fila.ejercito)),
                          onKeydown: _withKeys(($event: any) => (emit('ver', fila.ejercito)), ["enter"])
                        }, [
                          _createElementVNode("span", _hoisted_12, [
                            _createVNode(_component_v_icon, {
                              color: _unref(colorBando)(fila.bando),
                              size: "10",
                              class: "mr-1"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("mdi-circle")
                              ]),
                              _: 2
                            }, 1032, ["color"]),
                            _createTextVNode(_toDisplayString(fila.ejercito), 1)
                          ]),
                          _createElementVNode("span", {
                            class: _normalizeClass(["text-right", { 'text-medium-emphasis': fila.partidas < MINIMO }])
                          }, [
                            _createTextVNode(_toDisplayString(fila.partidas), 1),
                            (fila.partidas < MINIMO)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("*")
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 2),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(textoPorcentaje)(fila.porcentaje)), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["text-right", _unref(colorRinde)(fila.rinde)])
                          }, _toDisplayString(_unref(textoRinde)(fila.rinde)), 3)
                        ], 40, _hoisted_11))
                      }), 128)),
                      _createElementVNode("p", { class: "text-caption text-medium-emphasis mt-1 mb-0" }, " * Menos de " + _toDisplayString(MINIMO) + " partidas con ese ejército. "),
                      _hoisted_14,
                      (datos.value.rivalesDificiles.length === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_15, " No hay ningún ejército contra el que pierda más de lo que gana, con 3 partidas o más. "))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _hoisted_16,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datos.value.rivalesDificiles, (rival) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: rival.ejercito,
                                class: "fila text-body-2"
                              }, [
                                _createElementVNode("span", _hoisted_17, [
                                  _createVNode(_component_v_icon, {
                                    color: _unref(colorBando)(rival.bando),
                                    size: "10",
                                    class: "mr-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-circle")
                                    ]),
                                    _: 2
                                  }, 1032, ["color"]),
                                  _createTextVNode(_toDisplayString(rival.ejercito), 1)
                                ]),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(rival.partidas), 1),
                                _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(textoPorcentaje)(rival.porcentaje)), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["text-right", _unref(colorRinde)(rival.rinde)])
                                }, _toDisplayString(_unref(textoRinde)(rival.rinde)), 3)
                              ]))
                            }), 128)),
                            _hoisted_20
                          ], 64))
                    ], 64))
              ], 64))
            : _createCommentVNode("", true)
  ]))
}
}

})